import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';
import { useTranslations } from 'next-intl';
import type { QuizPlayerScore } from '@mentimeter/quiz-types';
import { NonInteractiveVisualizationWrapper } from '../../shared/components/NonInteractiveVisualizationWrapper';
import { CenteringContainer } from '../../shared/components/quiz/CenteringContainer';
import { TitleSection } from '../../shared/components/title-section/TitleSection';
import {
  NoResults,
  QuizLeaderboardVisualization,
} from './QuizLeaderboardVisualization';
import type { QuizLeaderboardPresentationProps } from './types';

interface ViewOnlyPresentationProps extends QuizLeaderboardPresentationProps {
  leaderboardResults: QuizPlayerScore[];
  CanvasVisualizationArea: InteractiveCanvasComponents['CanvasVisualizationArea'];
  shouldAnimate: boolean;
}

export const ViewOnlyPresentation = ({
  title,
  styledTitle,
  label,
  description,
  slidePublicKey,
  textSizeOffset,
  shouldAnimate,
  leaderboardResults,
  timeBasedScoring,
  CanvasVisualizationArea,
}: ViewOnlyPresentationProps) => {
  const t = useTranslations('presenting.quiz');
  const ConditionalWrapper =
    CanvasVisualizationArea ?? NonInteractiveVisualizationWrapper;
  return (
    <>
      <TitleSection
        title={title}
        styledTitle={styledTitle}
        label={label}
        fontSizeOffset={textSizeOffset}
        description={description}
        placeholder={t('leaderboard.placeholder_title')}
        showTextSizeDropdown={true}
        hideAIEditingSuggestions
      />
      <ConditionalWrapper width="100%" flex="1 1 auto">
        <CenteringContainer>
          {!leaderboardResults ||
          (leaderboardResults && leaderboardResults.length === 0) ? (
            <NoResults />
          ) : (
            <QuizLeaderboardVisualization
              results={leaderboardResults}
              enableAnimations={shouldAnimate}
              timeBasedScoring={timeBasedScoring}
              revealWinner={false}
              id={slidePublicKey}
            />
          )}
        </CenteringContainer>
      </ConditionalWrapper>
    </>
  );
};
